class CollectionScentFilter {
  constructor() {
    this.filterItems = document.querySelectorAll('.collection-scent-filter__item');
    this.productGrid = document.querySelector('#product-grid');
    this.productCount = document.querySelector('#ProductCountDesktop');
    this.pagination = document.querySelector('.pagination-wrapper');
    this.products = [];

    if (!this.productGrid) return;

    this.init();
  }

  init() {
    this.getAllProducts();

    this.filterItems.forEach((item) => {
      item.addEventListener('click', () => this.handleFilterClick(item));
    });

    // Check if there's a scent filter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const scentParam = urlParams.get('scent');

    if (scentParam) {
      const matchingFilter = Array.from(this.filterItems).find((item) => item.getAttribute('data-scent-filter').toLowerCase() === scentParam.toLowerCase());

      if (matchingFilter) {
        this.activateFilter(matchingFilter);

        if (this.areProductsFiltered()) {
          this.updateCount(this.countVisibleProducts());
          this.updateFacetCounts();
        } else {
          this.filterProducts(matchingFilter.getAttribute('data-scent-filter'), false);
        }

        this.updatePagination(false);
        return;
      }
    }

    const allFilter = Array.from(this.filterItems).find((item) => item.getAttribute('data-scent-filter').toLowerCase() === 'all');
    const defaultFilter = allFilter || this.filterItems[0];

    if (!defaultFilter) return;

    this.activateFilter(defaultFilter);

    if (allFilter) {
      this.updateCount(this.products.length);
      this.updatePagination(true);
    } else {
      this.filterProducts(defaultFilter.getAttribute('data-scent-filter'));
    }
  }

  activateFilter(item) {
    const radioInput = item.querySelector('input[type="radio"]');
    if (radioInput) radioInput.checked = true;

    this.filterItems.forEach((filterItem) => filterItem.classList.remove('active'));
    item.classList.add('active');
  }

  handleFilterClick(item) {
    const filterTag = item.getAttribute('data-scent-filter');
    this.activateFilter(item);
    this.filterProducts(filterTag);
    this.updateURL(filterTag);
  }

  getAllProducts() {
    const productItems = this.productGrid.querySelectorAll('.grid__item');

    productItems.forEach((item) => {
      const tags = item.getAttribute('data-product-tags');
      this.products.push({
        element: item,
        tags: tags ? tags.split(',').map((tag) => tag.trim()) : [],
      });
    });
  }

  filterProducts(filterTag) {
    const normalizedFilterTag = this.handleize(filterTag);
    const isShowingAll = normalizedFilterTag === 'all';

    const visibleCount = this.applyFilter(normalizedFilterTag, isShowingAll);
    this.updateCount(visibleCount);
    this.updateFacetCounts();
    this.updatePagination(isShowingAll);
  }

  applyFilter(filterTag, showAll) {
    let visibleCount = 0;

    this.products.forEach((product) => {
      const shouldShow = showAll || product.tags.some((tag) => tag === filterTag);
      product.element.style.display = shouldShow ? '' : 'none';
      if (shouldShow) visibleCount++;
    });

    return visibleCount;
  }

  countVisibleProducts() {
    return this.products.filter((product) => product.element.style.display !== 'none').length;
  }

  areProductsFiltered() {
    return this.products.some((product) => product.element.style.display === 'none');
  }

  updateCount(count) {
    if (this.productCount) {
      const productText = count === 1 ? 'product' : 'products';
      this.productCount.textContent = ` ${count} ${productText}`;
    }
  }

  updateFacetCounts() {
    const visibleCount = this.countVisibleProducts();
    const facetLabels = document.querySelectorAll('.facet-checkbox span[aria-hidden="true"]');

    facetLabels.forEach((label) => {
      if (label.textContent.includes('In stock')) {
        label.textContent = `In stock (${visibleCount})`;
      }
    });
  }

  updatePagination(isShowingAll) {
    if (this.pagination) {
      this.pagination.style.display = isShowingAll ? '' : 'none';
    }
  }

  handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  updateURL(filterTag) {
    const url = new URL(window.location);
    const normalizedFilterTag = this.handleize(filterTag);

    if (normalizedFilterTag === 'all') {
      url.searchParams.delete('scent');
    } else {
      url.searchParams.set('scent', normalizedFilterTag);
    }

    window.history.pushState({}, '', url);
  }
}

const initScentFilter = () => new CollectionScentFilter();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScentFilter);
} else {
  initScentFilter();
}
